import NextImage, { type ImageProps } from "next/image";
import { getAccessibleImageProps } from "@/lib/image-alt";

/**
 * next/image wrapper that treats CMS decorative alt (".") as alt="" + aria-hidden.
 */
export default function Image({
  alt,
  "aria-hidden": ariaHidden,
  ...props
}: ImageProps) {
  const accessible = getAccessibleImageProps(alt);

  return (
    <NextImage
      {...props}
      alt={accessible.alt}
      aria-hidden={accessible["aria-hidden"] ?? ariaHidden}
    />
  );
}
